// TODO: The usei18n hooks should not be used inside the condition. Should remove the condition.
// TODO: reafctor to avoid calling setState synchronously within an effect body which causes cascading renders that can hurt performance.
// TODO: Calling setState synchronously within an effect body causes cascading renders that can hurt performance

import { useState, useEffect } from 'react';

export const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
};
